export default __webpack_public_path__ + "static/media/down_blur.8efb81ac.svg";